import { Box, Card, Stack, Typography, getSpacing } from "@compass/core";
import {
  AprRequestFilter,
  AprResponseActivitiesAndServices,
  AprSssResponse as AprResponseModel,
  AprSection,
  AprSectionId,
  AprSectionItemId,
} from "generated/openApi";

import "moment-timezone";
import { GenericAprSection } from "./IIA/GenericAprSection";

export const AprTrioResponse = (props: {
  filter: AprRequestFilter;
  response: AprResponseModel;
  aprSections: AprSection[];
  selectedSectionItemIds: number[];
}) => {
  const sectionResponse = props.response.projectIdentifiers;

  const title = `Year: ${props?.filter?.schoolYear}`

  return (
    <Card>
      <Stack spacing="sm">
        {/* <Typography variant="h5">II.A</Typography> */}
        <Stack pl={getSpacing("lg")} spacing="xl">
          <GenericAprSection title={title} response={sectionResponse || {}} />
        </Stack>
      </Stack>
    </Card>
  );
};
